import { defineComponent, onMounted, ref } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import i18n from "@/lang"; // Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on t()

var t = i18n.global.t;
export default defineComponent({
  name: ModalComponents.PromocodeProcessing,
  setup: function setup() {
    var modalVisible = dialogVisibleForStatus(ModalStatus.PromocodeProcessing);
    var message = ref(t("promocode.processing-promocode"));
    onMounted(function () {
      // update message if syncing takes more than 10 seconds
      setTimeout(function () {
        message.value = t("promocode.taking-long");
      }, 10000);
    });
    return {
      modalVisible: modalVisible,
      message: message
    };
  }
});